import React from 'react'

// components
import {
  CRow,
  CCol,
  CFormLabel
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'
import FormTextAreaInput from '../general-input-form/FormTextAreaInput'
import FormSelectInput from '../general-input-form/FormSelectInput'
import FormFileUpload from '../general-input-form/FormFileUpload'
import FormFileThumbnail from '../general-input-form/FormFileThumbnail'

// helper
import { capitalizeFirstLetter } from 'src/helpers/text-format'

const AppForm = ({
  values,
  handleChange,
  errors,
  templateOption,
  templateValue,
  handleSelectTemplate,
  handleInputTemplateParam,
  templateHeaderComponents,
  handleFileInput,
  openPreview,
  handleConfirmDelete,
  recipientOption,
  recipientValue,
  handleSelectRecipient
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormSelectInput 
          id='template_name'
          name='template_name'
          colSize='6'
          className='mb-3'
          inputLabel='Template'
          selectOptions={templateOption}
          value={templateValue}
          handleSelectInput={handleSelectTemplate}
          feedbackInvalid={errors.template_name}
          invalid={errors.template_name}
          disabled={false}
        />
        <FormSelectInput 
          id='template_recipients'
          name='template_recipients'
          colSize='6'
          className='mb-3'
          inputLabel='Recipients'
          selectOptions={recipientOption}
          value={recipientValue}
          handleSelectInput={handleSelectRecipient}
          feedbackInvalid={errors.template_recipients}
          invalid={errors.template_recipients}
          disabled={false}
          multiple={true}
        />
      </CRow>
      {
        values?.template_name && (
          <CRow>
            <FormTextAreaInput
              id='template_message'
              name='template_message'
              colSize='8'
              inputLabel='Message'
              className='mb-3'
              rows='6'
              value={values.template_message}
              handleTextAreaInput={handleChange}
              disabled={true}
            />
            {
              templateHeaderComponents && templateHeaderComponents?.format !== 'TEXT' && (
                <CRow>
                  {
                    values?.file?.length > 0 ? (
                      <CCol lg={6}>
                        <CFormLabel>
                          {templateHeaderComponents?.format ? capitalizeFirstLetter(templateHeaderComponents?.format) : 'File'} Attachment
                        </CFormLabel>
                        <FormFileThumbnail 
                          name='template_file'
                          colSize='12'
                          files={values?.file}
                          className='justify-content-start align-items-center'
                          handleConfirmDelete={handleConfirmDelete}
                          handleViewFile={(e) => openPreview(templateHeaderComponents?.format?.toLowerCase(), e)}
                        />
                      </CCol>
                    )
                    : (
                      <FormFileUpload
                        name='template_file'
                        colSize='6'
                        handleFileInput={handleFileInput}
                        handleFileOnDrop={handleFileInput}
                        inputLabel={`${templateHeaderComponents?.format ? capitalizeFirstLetter(templateHeaderComponents?.format) : 'File'} Attachment`}
                        multiple={false}
                        feedbackInvalid={errors?.file}
                        invalid={errors?.file}
                        isSpesificType={true}
                        typeFile={templateHeaderComponents?.format?.toLowerCase()}
                        maxFiles={1}
                      />
                    )
                  }
                </CRow>
              )
            }
            {
              values?.template_parameters.map((item, index) => {
                return (
                  <FormTextInput 
                    id='template_parameters'
                    name='template_parameters'
                    colSize='6'
                    inputLabel={`params ${index + 1}`}
                    className='mb-3'
                    placeholder={`Enter params ${index + 1}...`}
                    value={item}
                    handleTextInput={(e) => handleInputTemplateParam(e, index)}
                    feedbackInvalid={errors?.template_parameters?.length > 0 && errors?.template_parameters[index]}
                    invalid={errors?.template_parameters?.length > 0 && errors?.template_parameters[index]}
                  />
                )
              })
            }
          </CRow>
        )
      }
    </>
  )
}

export default AppForm